import ConsentNavbar from "./ConsentNavbar";
import ConsentHero from "./ConsentHero";
import Audiences from "./Audiences";
import ConsentVariance from "./ConsentVariance";
import Channels from "./Channels";
import Templates from "./Templates";
import CookieConsent from "./CookieConsent";
import DSAR from "./DSAR";
import ConsentCTA from "./ConsentCTA";
import ConsentFooter from "./ConsentFooter";
import ZohoSalesIQ from "./ZohoSalesIQ";

export default function ConsentManagementPage() {
  return (
    <div className="bg-surface text-ink font-figtree">
      <ZohoSalesIQ />
      <ConsentNavbar />
      <ConsentHero />
      <Audiences />
      <ConsentVariance />
      <Channels />
      <Templates />
      <CookieConsent />
      <DSAR />
      <ConsentCTA />
      <ConsentFooter />
    </div>
  );
}
